import React, {useState} from 'react'
import {AuthenticateUser} from '../../../Utils/_helpers/RoleAndPermission'
import {REGION} from '../../../Utils/Constant/ConstantForWebsite'
import DedicatedNumberList from '../accounts/DedicatedNumber/DedicatedNumberList'
import BusinessNameList from '../accounts/BusinessName/BusinessNameList'
import CustomNumberList from '../accounts/CustomNumber/CustomNumberList'
import {useSelector} from 'react-redux'
import {
  getDefaultRegion,
  getIsDefaultRegion,
} from '../accounts/Overview/OverviewSlice/UserDetailsSlice'
import SenderIdInfoCard from './SenderIdInfoCard'
import ModalDetailDedicatedNumber from './modal/ModalDetailDedicatedNumber'
import ModalDetailCustomBusiness from './modal/ModalDetailCustomBusiness'
import ModalDetailCustomNumber from './modal/ModalDetailCustomNumber'

const SenderIdWrapper = () => {
  const [isShowCredit, setIsShowCredit] = useState(true)
  const isDefaultRegion = useSelector(getIsDefaultRegion)
  const currentRegion = useSelector(getDefaultRegion)
  const [showModalDedicatedNumber, setShowModalDedicatedNumber] = useState(false)
  const [showModalCustomBussines, setShowModalCustomBussines] = useState(false)
  const [showModalCustomNumber, setShowModalCustomNumber] = useState(false)
  const [showModalDetailDedicatedNumber, setShowModalDetailDedicatedNumber] = useState(false)
  const [showModalDetailCustomBusiness, setShowModalDetailCustomBusiness] = useState(false)
  const [showModalDetailCustomNumber, setShowModalDetailCustomNumber] = useState(false)

  return (
    <>
      <div className='d-flex gap-5 justify-content-between'>
        <SenderIdInfoCard
          showActionButton={AuthenticateUser('purchase-dedicated-number') && isShowCredit}
          imagePath='/media/svg/sender-id/dedicated-number.svg'
          title='Dedicated Number'
          description='Get a dedicated number for exclusive, trusted messaging, ensuring brand protection and direct customer communication.'
          actionButtonText='Get dedicated number'
          onClickActionButton={() => setShowModalDedicatedNumber(true)}
          onClickLearnMore={() => setShowModalDetailDedicatedNumber(true)}
        />
        <SenderIdInfoCard
          showActionButton={AuthenticateUser('create-new-business-name')}
          imagePath='/media/svg/sender-id/custom-business-name.svg'
          title={'Custom Business Name\n(Alpha ID)'}
          description='Use your business name as the sender for instant brand recognition, like Nike or Uber.'
          actionButtonText='Register business name'
          onClickActionButton={() => setShowModalCustomBussines(true)}
          onClickLearnMore={() => setShowModalDetailCustomBusiness(true)}
        />
        <SenderIdInfoCard
          showActionButton={AuthenticateUser('create-custom-number')}
          imagePath='/media/svg/sender-id/custom-number.svg'
          title='Register custom number'
          description='Send SMS from your own number for a personal touch, ensuring messages feel direct while replies and calls go straight to you.'
          actionButtonText='Register custom number'
          onClickActionButton={() => setShowModalCustomNumber(true)}
          onClickLearnMore={() => setShowModalDetailCustomNumber(true)}
        />

        <ModalDetailDedicatedNumber
          showActionButton={AuthenticateUser('purchase-dedicated-number') && isShowCredit}
          show={showModalDetailDedicatedNumber}
          handleClose={() => setShowModalDetailDedicatedNumber(false)}
          onClickActionButton={() => {
            setShowModalDetailDedicatedNumber(false)
            setShowModalDedicatedNumber(true)
          }}
        />
        <ModalDetailCustomBusiness
          showActionButton={AuthenticateUser('create-new-business-name')}
          show={showModalDetailCustomBusiness}
          handleClose={() => setShowModalDetailCustomBusiness(false)}
          onClickActionButton={() => {
            setShowModalDetailCustomBusiness(false)
            setShowModalCustomBussines(true)
          }}
        />
        <ModalDetailCustomNumber
          showActionButton={AuthenticateUser('create-custom-number')}
          show={showModalDetailCustomNumber}
          handleClose={() => setShowModalDetailCustomNumber(false)}
          onClickActionButton={() => {
            setShowModalDetailCustomNumber(false)
            setShowModalCustomNumber(true)
          }}
        />
      </div>
      {[REGION.US, REGION.UK].includes(currentRegion) || isDefaultRegion ? (
        <>
          <div className='mt-10'></div>
          {AuthenticateUser('show-dedicated-number') && (
            <DedicatedNumberList
              setShowCredit={setIsShowCredit}
              showModalNew={showModalDedicatedNumber}
              setShowModalNew={setShowModalDedicatedNumber}
              onClickLearnMore={() => setShowModalDetailDedicatedNumber(true)}
            />
          )}
        </>
      ) : null}

      {[REGION.UK].includes(currentRegion) || isDefaultRegion ? (
        <>
          {' '}
          <div className='mt-10'></div>
          {AuthenticateUser('show-business-name') && (
            <BusinessNameList
              showModalNewBusiness={showModalCustomBussines}
              setShowModalNewBusiness={setShowModalCustomBussines}
              onClickLearnMore={() => setShowModalDetailCustomBusiness(true)}
            />
          )}
        </>
      ) : null}
      {isDefaultRegion ? (
        <>
          <div className='mt-10'></div>
          {AuthenticateUser('show-custom-numbers') && (
            <CustomNumberList
              showModalNew={showModalCustomNumber}
              setShowModalNew={setShowModalCustomNumber}
              onClickLearnMore={() => setShowModalDetailCustomNumber(true)}
            />
          )}
        </>
      ) : null}
    </>
  )
}

export default SenderIdWrapper
